import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'app-range-slider',
  templateUrl: 'range-slider.component.html',
  styleUrls: ['range-slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: RangeSliderComponent,
    },
  ],
})
export class RangeSliderComponent implements ControlValueAccessor, OnChanges {
  @ViewChild('inputEl', { static: true })
  inputRef: ElementRef<HTMLInputElement>;

  formControl: FormControl<number>;

  @Input()
  value: number;
  @Output()
  valueChange = new EventEmitter<number>();
  @Output()
  onChanged = new EventEmitter<number>();

  private onChange = (value) => {};

  private onTouched = () => {};

  @Input()
  step: number = 1;
  @Input()
  min: number = 0;
  @Input()
  max: number = 100;

  @Input()
  get disabled() {
    return !!this.formControl.disabled;
  }

  set disabled(value) {
    value = !!value;
    if (value === this.disabled) {
      return;
    }

    if (value) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }

    this.changeDetector.detectChanges();
  }

  @Input()
  linearColorStopList: [string, string];

  get valuePercent() {
    return ((this.value - this.min) / (this.max - this.min)) * 100;
  }

  constructor(
    private formBuilder: FormBuilder,
    private changeDetector: ChangeDetectorRef
  ) {
    this.formControl = this.formBuilder.control(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.linearColorStopList) {
      const [linearColorStopOne, linearColorStopTwo] =
        changes.linearColorStopList.currentValue;

      this.inputRef.nativeElement.style.setProperty(
        '--rangeslider-gradient-color-initial',
        linearColorStopOne
      );
      this.inputRef.nativeElement.style.setProperty(
        '--rangeslider-gradient-color-current',
        linearColorStopTwo
      );

      this.inputRef.nativeElement.style.setProperty(
        '--rangeslider-color',
        linearColorStopTwo
      );
    }

    if (changes.value) {
      this._setInputValue();
    }
  }

  writeValue(value: number): void {
    if (this.value !== value) {
      this.value = value;
      this._setInputValue();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(e) {
    const value = this.inputRef.nativeElement.valueAsNumber;
    this.emitValue(value);
  }

  onRangeChange(e) {
    this.onChanged.emit(this.value);
  }

  private _setInputValue() {
    this.formControl.reset(this.value);

    this.changeDetector.detectChanges();
  }

  private emitValue(value: number) {
    if (this.value !== value) {
      this.value = value;
      this.valueChange.emit(this.value);

      this.onChange?.(value);
    }
  }
}
